import type { AdminRefundStatus } from '@carcheck/shared';
import Chip, { type ChipProps } from '@mui/material/Chip';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Refund status badge chip for the history list (AUT-129). The wire
 * derives status from `processedAt` (no DB status column) → only two
 * values:
 *   - completed → success "выполнен"
 *   - failed    → error   "не прошёл"
 *
 * Labels resolve through i18n (`refunds.status.<value>`; CLAUDE.md
 * rule #11).
 */
type ChipColor = ChipProps['color'];

const STATUS_COLOR: Record<AdminRefundStatus, ChipColor> = {
  completed: 'success',
  failed: 'error',
};

export const RefundStatusBadge = ({ status }: { status: AdminRefundStatus }): ReactElement => {
  const { t } = useTranslation();
  return <Chip size="small" color={STATUS_COLOR[status]} label={t(`refunds.status.${status}`)} />;
};
